var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotionIcon22(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st000{fill:#C6007E;}\n\t.st1000{fill:#01BEDB;}\n\t.st2000{fill:#0047BB;}\n\t.st3000{fill:#8B8C8C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st000",
    d: "M22,12c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S16.5,12,22,12 M22,0C9.8,0,0,9.8,0,22s9.8,22,22,22 s22-9.8,22-22S34.2,0,22,0L22,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1000",
    d: "M88,12v20H68V12H88 M100,0H56v44h44V0L100,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2000",
    d: "M78,68c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S72.5,68,78,68 M78,56c-12.2,0-22,9.8-22,22 s9.8,22,22,22s22-9.8,22-22S90.2,56,78,56L78,56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3000",
    d: "M32,68v20H12V68H32 M44,56H0v44h44V56L44,56z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionIcon22);
export default __webpack_public_path__ + "static/media/motion_icon-22.f7d0e660.svg";
export { ForwardRef as ReactComponent };